import { StyleSheet } from "react-native";
import { helpTextStyle } from "../primitives/helpTextStyle";
import type { UiTheme } from "../theme";
import { scaled } from "../pictureScale";

// Styles for ProgressView (header, collapsed widgets) and its Rhythm widget
// (the total/7d/30d/last-session stat grid + the weekly-frequency bar chart,
// lifted from mobile's progressScreenStyles). The host owns the scroll
// container + its padding.

// #321: under this window width, or from this system text size, a stat box
// takes the whole row: two side by side cut a long label mid-word.
export const STAT_ONE_COLUMN_WIDTH = 340;
export const STAT_ONE_COLUMN_FONT_SCALE = 1.3;

export function makeProgressViewStyles(theme: UiTheme) {
  const { palette: p, spacing: s, radius: r, typography: t } = theme;
  return StyleSheet.create({
    // PG-64: the report door opens the page; wide, the Customize door sits
    // at the other end of the same row (PG-62, as on Home).
    header: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      gap: s.s3,
    },
    // Narrow: the Customize door, quiet and centred at the foot of the page.
    customize: { alignSelf: "center" },
    // The Rhythm widget: its counts above its bars.
    rhythm: { gap: s.s4 },
    statGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: s.s3,
    },
    stat: {
      flex: 1,
      minWidth: "45%",
      flexDirection: "column",
      gap: s.s2,
      backgroundColor: p.surface,
      borderColor: p.border,
      borderWidth: scaled(theme, 1),
      borderRadius: r.r3,
      paddingHorizontal: s.s4,
      paddingVertical: s.s3,
    },
    statFull: { minWidth: "100%" },
    statLabel: {
      color: p.ink2,
      // The sm floor (DS-16), for Rhythm too.
      fontSize: t.sizes.sm,
      fontWeight: "700",
      letterSpacing: scaled(theme, 0.6),
      textTransform: "uppercase",
      flexShrink: 1,
    },
    statValue: {
      color: p.ink,
      fontSize: t.sizes.lg,
      fontWeight: "600",
      fontFamily: t.fonts.mono,
      fontVariant: ["tabular-nums"],
    },
    // PG-58: a streak number and its unit on one baseline.
    statValueRow: {
      flexDirection: "row",
      alignItems: "baseline",
      gap: s.s1,
    },
    card: {
      backgroundColor: p.surface,
      borderColor: p.border,
      borderWidth: scaled(theme, 1),
      borderRadius: r.r3,
      paddingHorizontal: s.s4,
      paddingVertical: s.s4,
      gap: s.s3,
    },
    cardTitle: {
      color: p.ink,
      fontSize: t.sizes.base,
      fontWeight: "600",
    },
    cardHelp: helpTextStyle(theme),
  });
}
